import type { ContactInfo } from "../../aysa_api/models/contact_info.types";
import { Reader, Writer } from "protobufjs/minimal";

export const createBaseContactInfo = (): ContactInfo => {
  return {
    href: "",
    label: "",
  };
};

export const decodeContactInfo = (
  reader: Reader,
  length: number
): ContactInfo => {
  const end = reader.pos + length;
  const message = createBaseContactInfo();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.href = reader.string();

        break;
      case 2:
        message.label = reader.string();

        break;
      case 3:
        message.description = reader.string();

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeContactInfo = (
  writer: Writer,
  message: ContactInfo
): Writer => {
  writer.uint32(10).string(message.href);
  writer.uint32(18).string(message.label);
  if (message.description !== undefined) {
    writer.uint32(26).string(message.description);
  }

  return writer;
};
